export default "__VITE_ASSET__TUduPp2M__"